export default {
    computed: {
        escalationName() {
            return _.has(this.user, 'organisation_settings.escalation_name') ? this.user.organisation_settings.escalation_name : 'escalatie'
        }
    },

    methods: {
        invoiceStatus(status) {
            switch (status) {
                case null:
                case 'open':
                    return 'Open';
                case 'open_due':
                    return 'Open';
                case 'paid':
                    return 'Betaald';
                case 'partly_paid':
                    return 'Deels betaald';
                case 'one_fail':
                    return 'Betalingsfout';
                case 'multiple_fails':
                    return 'Betalingsfouten';
                case 'incasso_planned':
                    return 'Incasso aangemeld';
                case 'cancelled':
                    return 'Geannuleerd';
                case 'reminder_1':
                    return '1e herinnering';
                case 'reminder_2':
                    return '2e herinnering';
                case 'reminder_3':
                    return '3e herinnering';
                case 'storno':
                    return 'Gestorneerd';
                case 'error':
                    return 'Error';
                case 'no_payment':
                    return 'Geen betaling';
                case 'escalated':
                    return 'Geëscaleerd';
                case 'escalated_send':
                    return 'Deurwaarder';
                case 'escalated_done':
                    return 'Afgerond';
                case 'hold':
                    return 'Wacht op bevestiging';
                default:
                    return status
            }
        },
    }
}
